// extracted by mini-css-extract-plugin
export var button = "_ce-2";
export var iconWrapper = "_ce-0";
export var investigatingIcon = "_ce-1";